import React from "react"
import {Button, Divider, Icon, Progress, Segment} from "semantic-ui-react"
import {Link, withRouter} from "react-router-dom"
import _ from "lodash"
import api from "../api"
import MFR from "../presentation/MFR"
import TopNavigation from "./components/TopNavigation"
import {useTranslation, Trans} from 'react-i18next'

let currentStepNumber = 0

export default function TasksPage() {

    currentStepNumber = 0
    let tasks = api.order.Steps.map((step, key) => <Task key={key} step={step}/>)
    let progress = api.getProgress()
    let firstStep = getFirst(api.order.Steps)
    let stepsFinished = api.getFinishedSteps()
    let steps = api.getSteps().length

    const {t} = useTranslation();

    return (
        <div className="">
            <TopNavigation/>
            <div className="transition-item section-full section--center ph2 ">
                <Segment textAlign="center">
                    <div className="pt4 pb3">
                        {progress === 100 ? <Button className="pb3 " size="huge" circular icon="checkmark"/> :
                            <Button className="pb3" basic size="huge" circular icon="info"/>
                        }
                        <div className="pa3">
                            <Trans i18nKey="general.step.finished">
                                Sie haben {{stepsFinished}} von {{steps}} Schritten bearbeitet
                            </Trans>

                        </div>
                        {progress === 100 ? <Button color="green" as={Link}
                                                    to={`/documents`}>{t("general.attachment.manage")}</Button> :
                            <Link to={`/tasks/${firstStep.Id}`}><Button
                                color="green">{t("general.start")}</Button></Link>
                        }
                    </div>
                </Segment>

                <Progress percent={progress}
                          progress
                          indicating
                          autoSuccess
                          color="green"/>
                <div className="section-full section--center ">
                    {tasks}
                    <div className="tr mt3 mb4">
                        <Link to="/accept/accepted">
                            <Button icon="chevron left"/>
                        </Link>
                        <Link to="/documents">
                            <Button className="no-margin-right" color='green'>{t("general.attachments")}<Icon
                                name="chevron right"/></Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

let currentDepth = 0

const Task = withRouter(({step, history}) => {

    const {t} = useTranslation();
    if (step.TypeCode === "Group") {
        return (
            <Divider horizontal
                     inverted>{step.Name}</Divider>
        )
    }

    if (step.TrackingId === api.TRACK_ID_EXTRA_SIGNATURE) return null // External Signature is handled in a dedicated UI Step
    if (step.TypeCode === "Material") return null // MaterialStep not implemented
    currentStepNumber++
    api.stepnumbers.set(step.Id, currentStepNumber)
    let out = (
        <div>{step.Depth < currentDepth ? <Divider horizontal inverted/> : null}
            <Segment className="segment-task "
                     style={{cursor: "pointer"}}
                     onClick={() => {
                         history.push("/tasks/" + step.Id)
                     }}>

                <div className="fr">
                    <IsDone step={step}/>
                    <HasError step={step}/>
                    <CanEdit step={step}/>
                </div>

                <div>
                    <span className="black-60 f6">{t("general.step.single")} {currentStepNumber}</span>
                    <MFR.Title>{step.Name}</MFR.Title>
                    {step.Description ?
                        <div className="step-description" dangerouslySetInnerHTML={{__html: step.Description}}/> : null}
                </div>
            </Segment>
        </div>
    )

    currentDepth = step.Depth
    return out
})

const IsDone = ({step}) => {
    const {t} = useTranslation();

    if (step.IsDone) {
        return <Button style={{marginTop: "-5px"}} size="mini" color='green'>{t("general.done")}</Button>
    }
    return null
}

const HasError = ({step}) => {
    const {t} = useTranslation();

    if (step.HasError) {
        return <Button style={{marginTop: "-5px"}} size="mini" color='yellow'>{t("general.rework")}</Button>
    }
    return null
}

const CanEdit = ({step}) => {
    const {t} = useTranslation();

    if (!step.IsDone) {
        return <Button style={{marginTop: "-5px"}} size="mini">{t("general.edit")}</Button>
    }
    return null
}

const getFirst = (steps) => {
    let validSteps = steps.filter(step => _.includes(api.config.SUPPORTED_STEPS, step.TypeCode))
    let step = validSteps[0]
    return step
}




// WEBPACK FOOTER //
// ./src/pages/TasksPage.js